// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d99803fe","453":"d855a71b","455":"5e029012","977":"ed5dca5f"}[chunkId] + ".chunk.js";
};